import { useContext } from 'react';
import { useQuery } from 'react-query';
import { rootKeys } from '../cache-keys/rootKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_quote } from '@axo/shared/data-access/types';
import { loan_quote_api } from '@axo/shared/data-access/api';

export function useQuoteStatuses() {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = rootKeys.quoteStatuses();

  return useQuery(cacheKey, loan_quote_api.getQuoteStatuses(api), {
    enabled: state.user.token.length > 0,
  });
}

export function useQuoteStatusUtils() {
  const statuses = useQuoteStatuses();

  return {
    isInQuoteStatusGroup(
      status: loan_quote.LoanQuoteStatus | undefined,
      group: loan_quote.QuoteStatusGroup
    ) {
      if (!statuses.data || !status) return false;
      try {
        const match = statuses.data[status];
        return match.Groups.includes(group);
      } catch (e) {
        console.error('Status not found', status);
        return false;
      }
    },
    fromCode(code: number) {
      const entries = Object.entries(statuses.data ?? {}) as [
        loan_quote.LoanQuoteStatus,
        loan_quote.QuoteStatuses[loan_quote.LoanQuoteStatus]
      ][];
      return entries
        .map(([Status, { Code }]) => ({ Status, Code }))
        .find(({ Code }) => code === Code)?.Status;
    },
  };
}
